export default __webpack_public_path__ + "static/media/2017.c0b98330.webp";